// extracted by mini-css-extract-plugin
export default {"root":"_16g1N"};